/**
 * Klaviyo onsite form triggers.
 *
 * Opens a brand-specific Klaviyo signup form when a "Join Our Mailing List"
 * link is clicked. The links are merchant-configured (footer menu / content)
 * with a hash target of `#email-opt-in-<brand>`; the hash maps to a Klaviyo
 * form ID below.
 *
 * Delegated on `document` so links rendered after load (menus, drawers,
 * dynamically-injected footers) are covered without re-binding. The click is
 * pushed onto Klaviyo's `_klOnsite` queue, which buffers until onsite.js loads,
 * so there is no dependency on Klaviyo's script load order.
 */
(function () {
  'use strict';

  /** Hash anchor (brand) -> Klaviyo form ID. */
  var FORM_IDS = {
    'email-opt-in-hall': 'RUuDqK',
    'email-opt-in-walt': 'Yy5SNe',
    'email-opt-in-baca': 'Sr8Vaf',
    'email-opt-in-foch': 'UTc7ue'
  };

  document.addEventListener('click', function (event) {
    var el = event.target instanceof Element ? event.target : null;
    var link = el && el.closest('a[href*="#email-opt-in-"]');
    if (!link) return;

    var anchor = (link.hash || '').replace(/^#/, '');
    var formId = FORM_IDS[anchor];
    if (!formId) return;

    event.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
})();
